import axiosPrivate from "./axiosPrivate";

const getSeguimientoBoleta = (params) => {
  return axiosPrivate.post("getSeguimientoBoleta", params)
    .then(response => response.data);
};

const getDnisDisponibles = (gestor_id) => {
  return axiosPrivate.post("getDnisDisponibles", { gestor_id })
    .then(response => response.data);
};

const registrarBoleta = (data) => {
  return axiosPrivate.post("registrarBoleta", data)
    .then(response => response.data);
};

export default {
  getSeguimientoBoleta,
  getDnisDisponibles,
  registrarBoleta
};
